export default function notificationsReducer(
    state: any = {
        notificationList: {
            loading: false,
            done: false,
            response: null,
            error: null,
            success: null,
        },
        readNotifications: {
            loading: false,
            done: false,
            response: null,
            error: null,
            success: null,
        },
    },
    action: any) {

    switch (action.type) {

        /**
         *     Get notifications reducer
         */
        case 'FETCH_GET_NOTIFICATIONS_PENDING': {
            return { ...state, notificationList: { loading: true, success: null } }
        }

        case 'FETCH_GET_NOTIFICATIONS_REJECTED': {
            return { ...state, notificationList: { loading: false, error: action.payload, success: false } }
        }

        case 'FETCH_GET_NOTIFICATIONS_FULFILLED': {
            return { ...state, notificationList: { loading: false, done: true, error: null, response: action.payload } }
        }

        /**
         *     Post notifications reducer
         */
        case 'FETCH_POST_NOTIFICATIONS_PENDING': {
            return { ...state, readNotifications: { loading: true, success: null } }
        }

        case 'FETCH_POST_NOTIFICATIONS_REJECTED': {
            return { ...state, readNotifications: { loading: false, error: action.payload, success: false } }
        }

        case 'FETCH_POST_NOTIFICATIONS_FULFILLED': {
            return {
                ...state, readNotifications: { loading: false, done: true, error: null, response: action.payload },
            }
        }

        /**
         *     Default
         */
        default: {
            return { ...state }
        }

    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/reducers/notifications.ts